module.exports = __webpack_public_path__ + "img/visa.b3ec442d.svg";